module.exports = __webpack_public_path__ + "img/Flag_of_Syria.7cb6d887.svg";